import type { ExperienceLike } from '@ninetailed/experience.js-utils'

export function normalizeApolloNtExperiences<
  U extends { id: string } = { id: string }
>(experienceData: any[]): ExperienceLike<U>[] {
  return (
    experienceData.map((el: any) => ({
      ...el,
      id: typeof el.id === 'object' ? el.id.id : el.id,
      variants: (!!el.variants?.length ? el.variants : el.variants.items).map(
        (v: any) => ({
          ...v,
          id: typeof v.id === 'object' ? v.id.id : v.id
        })
      ),
      audience: el.audience
        ? {
            ...el.audience,
            id:
              typeof el.audience.id === 'object'
                ? el.audience.id.id
                : el.audience.id
          }
        : null
    })) || []
  )
}
